<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div style="padding: 10px;">
          <div class="actionBarStyle">
            <el-row>
              <!-- <el-button type="primary" round @click="createClient()">开播</el-button>
              <el-button type="primary" round @click="closeClient()">停播</el-button> -->
            </el-row>
            <el-row>
              <!-- <div>适用于直播课、公开课、才艺表演、班会等</div> -->
            </el-row>
          </div>
        </div>
        <div style="padding-left: 20px;">
          <div style="font-size: 20px;font-weight: bold;text-align: center;">支持老师创业的快查直播</div>
          <div>
            <div style="font-size: 18px;margin-top: 20px;font-weight: bold;">怎么获得收益？</div>
            <div style="font-size: 18px;margin-top: 20px;">快查成绩上有大量家长和学生,老师可以在快查上直播各类课程,通过带货、家长助力等获得收益。如果免费做也可以,可以获得影响力。</div>
            <div style="font-size: 18px;margin-top: 20px;font-weight: bold;">为什么要在快查上做直播？</div>
            <div style="font-size: 18px;margin-top: 20px;">因为快查上都是学生家长或者学生，已经形成了类似您的朋友圈的私域流量，您可以考虑怎么盘活这些私域流量资源的问题。而在别的平台上您没有私域流量，需要从零开始，换句话说您没有粉丝。</div>
          </div>
          <div>
            <div style="font-size: 18px;margin-top: 20px;font-weight: bold;">适用哪些内容？</div>
            <div style="font-size: 18px;margin-top: 20px;">适用于直播课、公开课、才艺表演、班会等</div>
            <div style="font-size: 18px;margin-top: 20px;font-weight: bold;">怎么开通主播权限开始直播？</div>
            <div style="font-size: 16px;margin-top: 20px;">此功能只支持手机端快查成绩小程序端，请在手机端微信操作。</div>
            <div style="font-size: 16px;margin-top: 20px;">当主播老师，需要满足三步走。</div>
            <div style="font-size: 16px;margin-top: 20px;">第一步，通过手机端的实名认证(国家法律要求)。请用微信扫下面的二维码实名认证：</div>
            <div><img src="https://res.wx.qq.com/op_res/9rSix1dhHfK4rR049JL0PHJ7TpOvkuZ3mE0z7Ou_Etvjf-w1J_jVX0rZqeStLfwh" style="width:180px;height:180px;"></img></div>
            <div style="font-size: 16px;margin-top: 20px;">第二步，向客服申请主播权限，需要给客服（客服微信:wx34424698）提供您的微信号。查看微信号的方法如下：</div>
            <div><img src="http://www.sales1.top/score/images/wx_num.jpg" style="width:200px;"></img></div>
            <div style="font-size: 16px;margin-top: 20px;">第三步，微信扫下面的码就可以打开直播端，您就成为直播啦。</div>
            <div><img src="http://www.sales1.top/score/images/wx_author.png" style="width:200px;height:200px;"></img></div>
            <div style="font-size: 16px;margin-top: 20px;">讲题需要用手机支架，具体需要什么样的，请在某宝上自行购买。</div>
          </div>
          <div  style="font-size: 14px;margin-top: 20px;color:red;">特别说明:如果平台无法满足老师的创业需求，敬请联系客服提出需求，快查将尽快改进系统。</div>
          <div class="video_wrap">
            <div class="content">
              <!-- 远端视频 -->
              <div v-for="(item, index) in remoteStreamList" :key="index" class="remote-stream">
                <div v-html="item.view" :class="{ 'distant-stream': item.view }">
                </div>
              </div>
              <!-- 本地视频 -->
              <div id='local_stream' class="local-stream">
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>

    <!--    <el-dialog title="重要提示" :visible.sync="dialogVisible" width="30%">
      <span>{{msg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="delHelpRecord">删 除</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  import TRTC from 'trtc-js-sdk'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        client_: '',
        sdkAppId_: 1400618273,
        userId_: 'test',
        userSig_: 'eJwtzEELgjAYxvHvsmth7*Y2ndAxKZIoiw7iJdiyN9FEhxrRd8-U4-N74P8hl*jstKYmAWEOkOW4UZvS4h1Htqaxszc6v1UVahJQDiCpzzx3ekxfYW0GF0IwAJjUYvE3yUFRJn05VzAbskVH33Wi0tUz7*MwenCRxMfupF-hocnaBXd35b7cXqny9GZNvj8xkjFJ',
        roomId: 10,
        client: '', // 客户端服务
        remoteStream: '', // 远方播放流
        localStream: '', // 本地流
        remoteStreamList: [] // 远端小视频

        // SDKAPPIDConfig: '腾讯云自己申请的SDKAPPID',
        //       SECRETKEYConfig: '腾讯云自己申请的SECRETKEY',
        //       userId: '',
        //       roomId: null,
        //       client: '', // 客户端服务
        //       remoteStream: '', // 远方播放流
        //       localStream: '', // 本地流
        //       remoteStreamList: [] // 远端小视频

      }
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session
    },
    methods: {
      startLive() {
        console.log('创建....')
      },
      // 可以绑定在按钮上，点击按钮，进行视频通话
      createClient(roomId) {
        // this.userId = 'web_' + parseInt(Math.random() * 100000000)
        // this.roomId = roomId || '888'
        // this.localStream = ''
        this.remoteStreamList = []
        // 获取签名
        const sdkAppId = this.sdkAppId_
        const userSig = this.userSig_
        const userId = this.userId_
        this.client = TRTC.createClient({
          mode: 'rtc', // 实时音视频通话
          sdkAppId,
          userId,
          userSig
        })
        // 注册远程监听
        this.subscribeStream(this.client)
        // 注册监听事件 如，房间关闭
        this.handleEvents(this.client)
        // 初始化成功后才能加入房间
        this.joinRoom(this.client, this.roomId)
      },

      // 订阅远端流--加入房间之前
      subscribeStream(client) {
        client.on('stream-added', event => {
          const remoteStream = event.stream
          console.log('远端流增加: ' + remoteStream.getId())
          // 订阅远端流
          client.subscribe(remoteStream)
        })
      },

      handleEvents(client) {
        client.on('stream-subscribed', event => {
          const remoteStream = event.stream
          console.log('远端流订阅成功：' + remoteStream.getId())
          // 创建远端流标签，因为id是动态的，所以动态创建，用了v-html
          let remoteStreamItem = `<view id="${'remote_stream-' + remoteStream.getId()}"  ></view>`
          let isExist = this.remoteStreamList.find(item => item.userId === remoteStream.getUserId())
          if (!isExist) {
            this.remoteStreamList.push({
              id: remoteStream.getId(),
              userId: remoteStream.getUserId(),
              view: remoteStreamItem,
              hasVideo: true, // 是否开启了摄像头
              hasMic: true // 是否开启了麦克风
            })

            // 做了dom操作 需要使用$nextTick(),否则找不到创建的标签无法进行播放
            this.$nextTick(() => {
              // 播放远端流
              remoteStream.play('remote_stream-' + remoteStream.getId())
            })
          }
        })
      },

      // 加入房间
      joinRoom(client, roomId) {
        client.join({
            roomId
          })
          .catch(error => {
            console.error('进房失败 ' + error)
          })
          .then(() => {
            console.log('进房成功')
            // 创建本地流
            this.createStream(this.userId)
          })
      },
      // 创建本地音频流
      async createStream(userId) {
        const localStream = TRTC.createStream({
          userId,
          audio: true,
          video: true
        })
        // 设置视频属性 Profile 为 '480p'
        localStream.setVideoProfile('480p')

        this.localStream = localStream

        try {
          await localStream
            .initialize()
            .catch(error => {
              console.error('初始化本地流失败 ' + error)
            })
            .then(() => {
              console.log('初始化本地流成功')
              // 创建好后才能播放 本地流播放 local_stream 是div的id
              localStream.play('local_stream')
              // 创建好后才能发布
              this.publishStream(localStream, this.client)
            })
        } catch (error) {
          switch (error.name) {
            case 'NotReadableError':
              alert(
                '暂时无法访问摄像头/麦克风，请确保系统允许当前浏览器访问摄像头/麦克风，并且没有其他应用占用摄像头/麦克风'
              )
              break
            case 'NotAllowedError':
              if (error.message === 'Permission denied by system') {
                alert('请确保系统允许当前浏览器访问摄像头/麦克风')
              } else {
                console.log('User refused to share the screen')
                alert('请确保系统允许当前浏览器访问摄像头/麦克风')
              }
              break
            case 'NotFoundError':
              alert(
                '浏览器获取不到摄像头/麦克风设备，请检查设备连接并且确保系统允许当前浏览器访问摄像头/麦克风'
              )
              break
            default:
              break
          }
        }
      },
      // 发布本地音视频流
      publishStream(localStream, client) {
        client
          .publish(localStream)
          .catch(error => {
            console.error('本地流发布失败 ' + error)
          })
          .then(() => {
            console.log('本地流发布成功')
          })
      },

      // 退出房间
      logoutHandler() {
        this.leaveRoom(this.client)
      },
      leaveRoom(client) {
        client
          .leave()
          .then(() => {
            console.log('退房成功')
            // 停止本地流，关闭本地流内部的音视频播放器
            this.localStream.stop()
            // 关闭本地流，释放摄像头和麦克风访问权限
            this.localStream.close()
            this.localStream = null
            this.client = null
            // 退房成功，可再次调用client.join重新进房开启新的通话。
          })
          .catch(error => {
            console.error('退房失败 ' + error)
            // 错误不可恢复，需要刷新页面。
          })
      },
      closeClient() {
        this.logoutHandler()
      }

    }
  }
</script>

<style>
  .local-stream {
    width: 500px;
    height: 500px;
  }

  .remote-stream {
    width: 200px;
    height: 200px;
  }

  .actionStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }
</style>



// WEBPACK FOOTER //
// src/components/live_class.vue